// 1 space's rows (data.js loadSpace), loaded when the page opens and kept here: a tick, an added
// action, a saved session or a new file changes the rows in place, so every part of the page shows
// it at once without loading again.
//
//   const cs = useClientSpace(spaceId, staff, productId)
//   cs.status: 'loading' | 'ready' | 'missing' | 'error'; cs.data: loadSpace's answer;
//   cs.patch(fn) replaces data with fn(data); cs.reload()
import { useCallback, useEffect, useRef, useState } from 'react'
import { loadSpace } from './data.js'

export function useClientSpace(spaceId, staff, productId = null) {
  const [s, set] = useState({ status: 'loading', data: null })
  const live = useRef(0)

  const reload = useCallback(() => {
    const n = ++live.current
    set(prev => ({ status: prev.data ? 'ready' : 'loading', data: prev.data }))
    return loadSpace(spaceId, { staff, productId })
      .then(data => { if (n === live.current) set(data ? { status: 'ready', data } : { status: 'missing', data: null }) })
      .catch(() => { if (n === live.current) set(prev => (prev.data ? prev : { status: 'error', data: null })) })
  }, [spaceId, staff, productId])

  useEffect(() => {
    set({ status: 'loading', data: null })
    reload()
    return () => { live.current++ }
  }, [reload])

  const patch = useCallback(fn => set(prev => (prev.data ? { ...prev, data: fn(prev.data) } : prev)), [])
  return { ...s, reload, patch }
}
